<div>
	<ng-template ngxAdHost></ng-template>
</div>
